module.exports = __webpack_public_path__ + "static/media/map-pin-outlined.12d4707c.svg";